import { render } from '@wordpress/element'
import Blog from './containers/Blog'

const reactBlogDomElements = document.querySelectorAll('.ls-react-blog')

if ( typeof reactBlogDomElements !== 'undefined' && reactBlogDomElements.length > 0 ) {

    reactBlogDomElements.forEach((element) => {

        // Fetch settings from shortcode
        const perPageSetting = element.getAttribute('data-per-page') ?? 6
        const apiDomainSetting = element.getAttribute('data-api-domain') ?? ''
        const initialPosts = element.getAttribute('data-initial-posts') ?? ''
        const initialAuthors = element.getAttribute('data-initial-authors') ?? ''

        // Render the Blog component into the DOM
        render(
            <Blog
                perPage={ parseInt(perPageSetting) }
                apiDomain={ apiDomainSetting }
                apiPath="/wp-json/wp/v2"
                initialPosts={initialPosts}
                initialAuthors={initialAuthors}
            />,
            element
        );
    })

}